import React from "react";

import { IgSwitch } from "@intelligems/ig-theme";
import { FormControlLabel, Grid } from "@mui/material";

import { ScopedComponentWithDisable } from "../../../../../components/ScopeWrappers/ScopedComponentWithDisable";
import type { ConfigurationInputProps } from "../../../../../types/organization";
import { toProperCaseWithSpaces } from "../../../../../utils";

import { BooleanConfigInput } from "./BooleanConfigInput";
import { JsonConfigInput } from "./JsonConfigInput";
import { ListConfigInput } from "./ListConfigInput";
import { StringOrNumberInput } from "./StringOrNumberInput";

export const ConfigurationInput = ({
  config,
  onChange,
}: ConfigurationInputProps) => {
  if (config.key === "shopify_functions_for_pricing_enabled") {
    return (
      <Grid
        item
        sx={{
          "& .MuiTypography-root": {
            marginLeft: "10px",
          },
        }}
      >
        <FormControlLabel
          control={
            <ScopedComponentWithDisable
              isEnabled={true}
              requiredShopifyScopes={[
                "read_cart_transforms",
                "write_cart_transforms",
              ]}
              debugId={"shopify_functions_for_pricing_enabled"}
            >
              <IgSwitch
                checked={config.value}
                color="primary"
                onClick={() => {
                  onChange(!config.value);
                }}
              />
            </ScopedComponentWithDisable>
          }
          label={toProperCaseWithSpaces(config.key)}
        />
      </Grid>
    );
  }
  return (
    <Grid item>
      {config.type === "Boolean" ? (
        <BooleanConfigInput onChange={onChange} config={config} />
      ) : config.type === "List" ? (
        <ListConfigInput onChange={onChange} config={config} />
      ) : config.type === "Json" ? (
        <JsonConfigInput onChange={onChange} config={config} />
      ) : config.type === "String" ||
        config.type === "Integer" ||
        config.type === "Float" ? (
        <StringOrNumberInput onChange={onChange} config={config} />
      ) : null}
    </Grid>
  );
};
